import { Table } from "@mantine/core";
import GreenTickMarkSvg from "../../../../components/Svgs/GreenTickMarkSvg";
import { RxCross1 } from "react-icons/rx";

/**
 * Renders a payment details table displaying the features and pricing 
 * of a selected token package. The table includes details such as Skai 
 * Revisions, Voice Record, All Staffs, Credits, and Total price.
 *
 * @param {Object} props - Component properties.
 * @param {string} props.selectedTab - Currently selected tab, determining if the purchase is one-time or monthly.
 * @param {Array} props.tokenPackages - Array of available token packages.
 * @param {string} props.selectedPackage - ID of the selected package to display details for.
//  * @param {string} props.customCredits - string of custom credits if the package plan is custom.
//  * @param {string} props.customPrice - Custom price if the package plan is custom.
 * @param {Object} props.classes - CSS classes for styling the table.
 */

export const PaymentDetailsTable = ({
  selectedTab,
  tokenPackages,
  selectedPackage,
  // customCredits,
  // customPrice,
  classes,
}) => {
  const pkg = tokenPackages?.find((item) => item._id === selectedPackage);

  return (
    <Table withBorder withColumnBorders>
      <thead>
        <tr className={classes.tableHeader}>
          <th>Features</th>
          <th style={{ textAlign: "center" }}>
            {selectedTab === "onetime-purchase" ? "One time" : "Monthly"}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Skai Revisions</td>
          <td style={{ textAlign: "center" }}>
            {pkg?.revisions === true ? (
              <GreenTickMarkSvg width={24} height={24} />
            ) : <RxCross1 width={24} height={24} color="red" />}
          </td>
        </tr>
        <tr>
          <td>Speech to Text</td>
          <td style={{ textAlign: "center" }}>
            {pkg?.voiceRecording === true ? (
              <GreenTickMarkSvg width={24} height={24} />
            ) : <RxCross1 width={24} height={24} color="red" />}
          </td>
        </tr>
        {/* <tr>
          <td>All Staffs</td>
          <td style={{ textAlign: "center" }}>
            {pkg?.allStaff === true ? (
              <GreenTickMarkSvg width={24} height={24} />
            ) : <RxCross1 width={24} height={24} color="red" />}
          </td>
        </tr> */}
        <tr>
          <td>Credits</td>
          <td style={{ textAlign: "center",  }}>
            {pkg?.tokens === "unlimited" ? "Unlimited" : pkg?.tokens || 0}
          </td>
        </tr>
        <tr>
          <td>Total</td>
          <td style={{ textAlign: "center" }}>
            ${pkg?.price || 0}
          </td>
        </tr>
      </tbody>
    </Table>
  );
};
